module.exports = "#tradingviewContainer{position:fixed;top:0;bottom:0;left:0;right:0}"